import { initSign, getSign } from "@didi/wsgsig";
import urlQs from "./urlQS";
import _ from "lodash";

/**
 * 对接口进行加签操作，加固接口 https://cooper.didichuxing.com/docs/document/2200553116152
 * bizId // 找 @冯威 生成 需要一下参数
 * 业务线：客服-客服中心
 * 业务线名：kefu-center
 *  */

const initWsgsigSign = (bizId = "4301e33a5ed11f9b22b2adccc445b1ec", appVer = "5.0.11", os = "4") => {
  initSign({ bizId, appVer, os })
}

const getWsgsigSign = (url, param, data, contentType) => {
  let wsgsigSign = '';
  try {
    const signParams = {};
    const urlParams = urlQs.parse(url);
    signParams.contentType = contentType;

    // 防止url上携带params参数
    if (param) {
      signParams.params = param;
    }

    if (!_.isEmpty(urlParams)) {
      signParams.params = { ...signParams.params, ...urlParams }
    }

    if (_.includes(_.toLower(contentType), 'text/plain')) {
      return getSign(signParams);
    }

    // 字符串的话使用bodyString字段，文件上传有这种情况
    if (_.isString(data)) {
      signParams.bodyString = data;
    }

    if (!_.isEmpty(data)) {
      signParams.body = data;
    }

    // 生成带签名的参数
    wsgsigSign = getSign(signParams);

  } catch (e) {
    console.error(`生成加签参数过程中出现错误,${e}`);
  }
  return wsgsigSign;
}

export default { getWsgsigSign, initWsgsigSign };